const LoadingSpinner = ({ color = 'gray', size = '1' }: { color?: string; size?: string }) => {
  return (
    <div className="flex h-full items-center justify-center">
      <div className={`animate-spin rounded-full h-${size} w-${size} border-b-2 border-t-2 border-${color}-900`} />
    </div>
  );
};

export default LoadingSpinner;
